module.exports = __webpack_public_path__ + "static/media/ic-actions-list-add.8a543991.svg";